import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { useHistory } from 'react-router-dom';
import AdminDashboardLayout from '../../../layouts/AdminDashboardLayout';
import { OrganizationsTable } from '../SchoolList/modules/OrganizationsTable';
import { AdminListTabs } from '../components/AdminListTabs';
import { ADMIN_ROUTES, ROUTES } from '../../../util/vars';

const OrganizationListPageComponent = () => {
  const { translate: t } = useI18n();
  const history = useHistory();

  const gotoOrganization = (organizationId: number) => {
    history.push(`${ROUTES.superAdmin}${ADMIN_ROUTES.organization}/${organizationId}${ADMIN_ROUTES.implementation.home}${ADMIN_ROUTES.implementation.organizationWeeklyLeadersEmail}`);
  };

  return (
    <AdminDashboardLayout title={t('pages.ADMIN.HEADER')}>
      <AdminListTabs active={'organizations'} />
      <OrganizationsTable onClickEdit={gotoOrganization} />
    </AdminDashboardLayout>
  );
};

export { OrganizationListPageComponent };
